import React from 'react';
import Riddle from '../Riddle'
function Level2({progress, failure}) {

  return (
    <Riddle prompt={"What's James' favorite color?"} correctAnswer={"yellow"} progress={progress} failure={failure}/>
  );
}

export default Level2;